import { useLayoutEffect, useState } from 'react';

// Tracks an element's rendered height, e.g. to offset a second sticky element below a sticky header.
// Returns a callback ref, so elements that mount later (after data loads) are measured too.
export default function useElementHeight<T extends HTMLElement>() {
    const [element, setElement] = useState<T | null>(null);
    const [height, setHeight] = useState(0);

    useLayoutEffect(() => {
        if (!element) return undefined;

        const measure = () => setHeight(element.getBoundingClientRect().height);

        measure();
        const ro = new ResizeObserver(measure);
        ro.observe(element);
        return () => ro.disconnect();
    }, [element]);

    return { ref: setElement, height };
}
